import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Message } from 'src/app/interfaces/message';
import { MessageService } from 'src/app/services/api/message.service';

@Component({
  selector: 'app-response-modal',
  templateUrl: './response-modal.component.html',
  styleUrls: ['./response-modal.component.scss']
})
export class ResponseModalComponent implements OnInit {

    @Input() message!: Message;
    @Input() ref!: string;

    public errorMessage: string = '';
    public errorType: string = '';
    
    public respondForm: FormGroup | undefined;

    public attachmentsArray : any[] = [];

    @ViewChild('fileInput') fileInput!: ElementRef;
    public fileAttr = 'Sélectionner un/plusieurs fichier(s)';
 
    value = 0; // Valeur en pourcentage

    totalSize = 0; // valeur en byte

    maxSize = 50000000; // 50Mo max

    constructor(public activeModal: NgbActiveModal,
                private messageService: MessageService) { }

    ngOnInit(): void {

        this.respondForm = new FormGroup({
            objet: new FormControl(this.setObjet()),
            content: new FormControl(this.setContent(), [Validators.required]),
            attachments: new FormControl('')
        });
    }

    respond(respondFormValue: any) {
        if (this.message && this.ref) {
            respondFormValue.attachments = this.attachmentsArray;
            this.messageService.respond(respondFormValue, this.ref).subscribe((res) => {
                if (res.result == 'SUCCESS') {
                    this.activeModal.close('');
                } else {
                    this.errorMessage = res.content;
                    this.errorType = res.result;
                }
            });
        }
    }
    
    public addAttachments = (attachments: any) => {
        if (attachments.files) {
            //@ts-ignore
            Array.from(attachments.files).forEach((file: File) => {
                if (!this.isAttachmentAllowed(file)) {
                    this.errorMessage = "ERRORS.CREATE.WRONG-FILE-FORMAT";
                    this.errorType = "ERROR"; 
                } else {
                    this.fileAttr += file.name + ' - ';
                    let fileReader = new FileReader();
                    fileReader.onload = (e) => {
                        let text = fileReader.result;
                        let totalFileSize = this.totalSize + file.size;
                        if (totalFileSize < this.maxSize) {
                            this.attachmentsArray.push({"name" : file.name, "content" : text, "size" : file.size });
                            this.updateProgressBar();
                            this.errorMessage = "CREATE.FORM.ATTACHMENT-ADD";
                            this.errorType = "SUCCESS";
                        } else {
                            this.errorMessage = "ERRORS.CREATE.MAX-SIZE";
                            this.errorType = "ERROR";
                        }  
                    }
                    fileReader.readAsDataURL(file);
                }
            });
        }
    }

    private isAttachmentAllowed(attachment: File) {

        if (attachment.type == "") {
            return false;
        }


        return true;
    }

    public hasError = (controlName: string, errorName: string) => {
        return this.respondForm?.controls[controlName].hasError(errorName);
    }

    private setObjet() {
        var objet = "";
        if (this.message) {
            if (this.message.objet.match(/^RE[ ]*:/i) === null) {
                objet = "Re : " + this.message.objet;
            } else {
                objet = this.message.objet;
            }
        }
        return objet;
    }

    private setContent() {

        var content = '<br /><hr id="sign" />';
        content += '<p><b>De : </b>' + this.message.sender + '</p>';
        content += '<p><b>Envoyé : </b> ' + this.message.date_envoi + '</p>';
        content += '<p><b>A : </b> ' + this.message.recipient + '</p>';
        content += '<p><b>Objet : </b> ' + this.message.objet + '</p>';
        content += this.message.content;

        return content;
    }

    private updateProgressBar() {

        let size = 0;

        // On calcule la taille totale des PJ ajoutée
        this.attachmentsArray.forEach((file: File) => {
            size = size + file.size;
        });

        this.totalSize = size;

        // Si la taille est supérieure à 0 on met à jour la progress bar
        if (size > 0) {
            this.value = Math.round(100 * size / this.maxSize); // On calcule le pourcentage de place restante (sur 50 Mo)
            if (this.value == 0) { // Si la taille est égale à 0 on affiche quand même 1%
                // Mise à jour champs HTML progress bar
                this.value = 1;
                this.updateBar(this.value.toString());
            } else { // Sinon on affiche le vrai pourcentage
                // Mise à jour champs HTML progress bar
                this.updateBar(this.value.toString());
            } 
        } else if (size == 0) { // Si la taille est à 0 (plus de PJ) on met à jour la progress bar à 0
            this.value = 0;
            // Mise à jour champs HTML progress bar
            this.updateBar(this.value.toString());
        }
    }

    private updateBar(value: string) {
        // Mise à jour champs HTML progress bar
        document.getElementById("progress-bar")?.setAttribute("aria-valuenow", value);
        document.getElementById("progress-bar")?.setAttribute("style", "width: " + value + "%");
        document.getElementById("progress-bar")!.innerHTML = value + "%";
    }

    public removeAttachment(index: number) {
        this.attachmentsArray.splice(index,1);
        this.updateProgressBar();
        this.errorType = "SUCCESS";
        this.errorMessage = "CREATE.FORM.ATTACHMENT-REMOVE";
    }

}
